import { getTeamLogoUrl } from '@/shared/services/getTeamLogoUrl';
import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';

const GameMatchup = ({ game }) => {
  const { homeTeam, awayTeam } = game;

  // The hooks run before the guard, not after. An early return above a useMemo
  // changes the hook count between renders, so the first render where team data
  // is still loading and the next one where it has arrived would throw
  // "rendered more hooks than during the previous render". Optional chaining is
  // what lets them run safely while the teams are still undefined.
  const homePrimaryTeamColor = useMemo(
    () =>
      game.homeTeamColor ||
      homeTeam?.teamColors?.find((c) => c.type === 'primary')?.hex_color ||
      '#000000',
    [game.homeTeamColor, homeTeam?.teamColors],
  );

  const awayPrimaryTeamColor = useMemo(
    () =>
      game.awayTeamColor ||
      awayTeam?.teamColors?.find((c) => c.type === 'primary')?.hex_color ||
      '#000000',
    [game.awayTeamColor, awayTeam?.teamColors],
  );

  if (!homeTeam || !awayTeam) return <></>;

  const awayLogoPath = getTeamLogoUrl(awayTeam);
  const homeLogoPath = getTeamLogoUrl(homeTeam);

  return (
    <div
      style={{
        // Team colors read as edge markers instead of a full-cell gradient:
        // away on the left, home on the right, matching the matchup order.
        borderLeft: `5px solid ${awayPrimaryTeamColor}`,
        borderRight: `5px solid ${homePrimaryTeamColor}`,
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{width: '100px', display: 'flex', justifyContent: 'flex-end'}}>
        <img loading="lazy" width="40" src={awayLogoPath} alt={awayTeam.abbreviation} />
      </Box>
      <Typography variant="h6">{awayTeam.abbreviation}</Typography>
      VS
      <Typography variant="h6">{homeTeam.abbreviation}</Typography>
      <Box sx={{width: '100px', display: 'flex', justifyContent: 'flex-start'}}>
        <img loading="lazy" width="40" src={homeLogoPath} alt={homeTeam.abbreviation} />
      </Box>
    </div>
  );
};

export default GameMatchup;
